// Arizona-correct date helpers. new Date().toISOString() is the UTC date, which
// from 5:00 PM Phoenix time onward is TOMORROW — using it for "today" made the
// day-of views default to the wrong day exactly during evening tour hours.
// Arizona is America/Phoenix (UTC-7, no DST).

/** Today's date (YYYY-MM-DD) on the Arizona wall clock. */
export const azTodayISO = (): string =>
  new Date().toLocaleDateString("en-CA", { timeZone: "America/Phoenix" });

/** ymd + n days, timezone-proof (pure calendar arithmetic via Date.UTC). */
export function plusDaysISO(ymd: string, days: number): string {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}

/**
 * A slot's start in minutes-from-midnight, or null if unknowable. Many live
 * Notion rows carry a date-only/midnight DATE prop while the real start time
 * lives in the START TIME select ("11:00 AM"), so a 00:00/blank hhmm falls
 * back to parsing the label. No FFT tour actually starts at midnight.
 */
export function slotStartMin(slot: { hhmm: string; startLabel: string }): number | null {
  const [h, m] = (slot.hhmm || "").split(":").map(Number);
  const fromHH = Number.isFinite(h) && Number.isFinite(m) ? h * 60 + m : null;
  if (fromHH != null && fromHH !== 0) return fromHH;
  const lm = /^(\d{1,2})(?::(\d{2}))?\s*([AP])\.?M\.?$/i.exec((slot.startLabel || "").trim());
  if (lm) {
    let lh = Number(lm[1]) % 12;
    if (/p/i.test(lm[3])) lh += 12;
    return lh * 60 + Number(lm[2] || 0);
  }
  // hhmm was 00:00 and the label didn't parse — the time is unknowable, not
  // midnight (a real "12:00 AM" label returns 0 from the branch above).
  return fromHH === 0 ? null : fromHH;
}
